import iccService from '../icc/iccService';

const login = async (languageCode) => {
    await iccService.fetchIccToken(languageCode);
};

export default {
    login,
};
